import { Component } from '@verndale/core';
import debounce from 'lodash/debounce';
import { sendValuesToZaiusAndBoxever } from '../helpers/ZaiusBoxeverEvents';
import validate from 'validate.js';
import { waitForElm } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      requestInfo: this.el.querySelector('.masthead__ctas'),
      requestInfoForm: this.el.querySelector('.masthead__form'),
      formCloseCTA: this.el.querySelector('#masthead__form-close-cta')
    };
    this.formOpen = false;
  }

  addListeners() {
    window.addEventListener('load', ::this.handleResize);
    window.addEventListener('resize', ::this.handleResize);
    this.dom.requestInfo.addEventListener('click', ::this.handleClick);
    this.dom.formCloseCTA.addEventListener('click', ::this.handleClick);
    document.addEventListener('touchmove', ::this.disableTouchScroll, { passive: false });
    document.addEventListener('wheel', ::this.disableTouchScroll, { passive: false });
  }

  disableTouchScroll(e){
    if (this.formOpen){
      e.preventDefault();
      e.stopPropagation();
    }
  }

  handleClick(e) {
    this.dom.requestInfoForm.classList.toggle('masthead__form-close');
    this.dom.requestInfoForm.scrollIntoView({ behavior: 'smooth' });
    this.formOpen = !this.formOpen;
  }

  handleResize(){
    this.isDesktop = window.matchMedia('(min-width: 1025px)').matches;
    if (!this.isDesktop) {
      this.dom.requestInfoForm.classList.add('masthead__form-close');
      this.formOpen = false;
    } else {
      this.dom.requestInfoForm.classList.remove('masthead__form-close');
      this.formOpen = false;
    }
  }

}

export default Module;
